const cardIndex = (card) => {
  const track = card.querySelector('[data-cv-card-track]');
  return track ? Math.round(track.scrollLeft / Math.max(track.clientWidth, 1)) : 0;
};

const updateCard = (card) => {
  const track = card.querySelector('[data-cv-card-track]');
  if (!track) return;
  const index = cardIndex(card);
  const count = track.children.length;
  const counter = card.querySelector('[data-cv-card-index]');
  if (counter) counter.textContent = String(index + 1);
  const previous = card.querySelector('[data-cv-card-arrow="-1"]');
  const next = card.querySelector('[data-cv-card-arrow="1"]');
  if (previous) previous.disabled = index <= 0;
  if (next) next.disabled = index >= count - 1;
};

document.addEventListener('click', (event) => {
  const arrow = event.target.closest('[data-cv-card-arrow]');
  if (arrow) {
    event.preventDefault();
    const card = arrow.closest('.cv-card--feed');
    const track = card?.querySelector('[data-cv-card-track]');
    if (track) track.scrollTo({ left: (cardIndex(card) + Number(arrow.dataset.cvCardArrow)) * track.clientWidth, behavior: 'smooth' });
    return;
  }
  const swatch = event.target.closest('[data-cv-card-swatch]');
  if (!swatch) return;
  event.preventDefault();
  const card = swatch.closest('.cv-card--feed');
  const track = card?.querySelector('[data-cv-card-track]');
  if (!track) return;
  card.querySelectorAll('[data-cv-card-swatch]').forEach((item) => item.setAttribute('aria-pressed', String(item === swatch)));
  card.querySelectorAll('[data-cv-card-link], .cv-card__slide').forEach((link) => {
    const url = new URL(link.href);
    url.searchParams.set('variant', swatch.dataset.variantId);
    link.href = url.toString();
  });
  const targetLeft = Number(swatch.dataset.imageIndex) * track.clientWidth;
  track.scrollTo({ left: targetLeft, behavior: 'auto' });
  requestAnimationFrame(() => {
    track.scrollLeft = targetLeft;
    updateCard(card);
  });
});

document.addEventListener('scroll', (event) => {
  if (event.target.matches?.('[data-cv-card-track]')) updateCard(event.target.closest('.cv-card--feed'));
}, true);
